// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"catalog"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21M8 3V21M16 9L8 9M16 15L8 15M16 21.0039H8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M21 8.99609L20.9961 8.99609L19 9L21 9V8.99609Z M21 14.9961H20.9961L19 15H21V14.9961Z M21 21H20.9961L19 21.0039H21V21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const Catalog1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'catalog-1',
    ref,
    icon: element,
  },
));

Catalog1Icon.displayName = 'Catalog1Icon';

export default Catalog1Icon;
